import { render, staticRenderFns } from "./academicAnalysis.vue?vue&type=template&id=5a3fd8ab&scoped=true"
import script from "./academicAnalysis.vue?vue&type=script&lang=js"
export * from "./academicAnalysis.vue?vue&type=script&lang=js"
import style0 from "./academicAnalysis.vue?vue&type=style&index=0&id=5a3fd8ab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3fd8ab",
  null
  
)

export default component.exports